import { render, staticRenderFns } from "./zaixun.vue?vue&type=template&id=dec4e546&scoped=true&"
import script from "./zaixun.vue?vue&type=script&lang=js&"
export * from "./zaixun.vue?vue&type=script&lang=js&"
import style0 from "./zaixun.vue?vue&type=style&index=0&id=dec4e546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec4e546",
  null
  
)

export default component.exports